"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
var tslib_1 = require("tslib");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var storage_1 = require("@jsmodules/storage");
var idgenerator_1 = require("../idgenerator");
var pipeline_1 = require("../pipeline");
var tasks_1 = require("../tasks");
var token_1 = require("../token");
var USER_STORAGE_KEY = "current_user";
var UserGetter = new pipeline_1.Pipeline();
var interceptors = {
    getUser: UserGetter,
};
var SessionService = /** @class */ (function () {
    function SessionService() {
        this.isAuthenticated = null;
        this._key = idgenerator_1.idgenerator.nextId();
        this.user = null;
    }
    Object.defineProperty(SessionService, "interceptors", {
        get: function () {
            return interceptors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "sessionStore", {
        get: function () {
            return storage_1.kvManager.get("SessionService", { encrypted: false });
        },
        enumerable: false,
        configurable: true
    });
    SessionService.prototype.getLoginedUser = function () {
        var _this = this;
        return this.initAsync().then(function () {
            return _this.user;
        });
    };
    SessionService.prototype.loginAsync = function (options) {
        var _this = this;
        return this.tokenService
            .login(options)
            .then(function () {
            return _this.updateAsync();
        })
            .then(function () {
            _this.isAuthenticated = true;
        })
            .catch(function (err) {
            _this.user = null;
            _this.isAuthenticated = false;
            return Promise.reject(err);
        });
    };
    SessionService.prototype.logoutAsync = function () {
        var _this = this;
        return this.tokenService
            .logout()
            .then(function () {
            return _this.sessionStore.removeAsync(USER_STORAGE_KEY);
        })
            .then(function () {
            _this.user = null;
            _this.isAuthenticated = false;
        });
    };
    SessionService.prototype.updateAsync = function () {
        var _this = this;
        return tasks_1.Task.throttleAsync("update-xv7uhjzhq", function () {
            return interceptors.getUser.exec().then(function (user) {
                _this.user = user;
                return _this.sessionStore.setAsync(USER_STORAGE_KEY, user);
            });
        });
    };
    SessionService.prototype.initAsync = function () {
        var _this = this;
        return tasks_1.Task.onceAsync("init-wdy7i7sqp", function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var access_token, user, ex_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.tokenService.getAccessToken()];
                    case 1:
                        access_token = _a.sent();
                        if (!access_token) {
                            this.isAuthenticated = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.sessionStore.getAsync(USER_STORAGE_KEY)];
                    case 2:
                        user = _a.sent();
                        if (!user) {
                            this.isAuthenticated = false;
                            return [2 /*return*/];
                        }
                        this.user = user;
                        this.isAuthenticated = true;
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _a.sent();
                        console.error(ex_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    SessionService.diOptions = di_1.default.options({
        name: "SessionService",
    });
    tslib_1.__decorate([
        di_1.default.Inject(token_1.TokenService)
    ], SessionService.prototype, "tokenService", void 0);
    return SessionService;
}());
exports.SessionService = SessionService;
